module.exports = __webpack_public_path__ + "img/pengadaan.d3ba1ae7.png";